import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-service-unavailable',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="service-unavailable-container">
      <div class="error-card">
        <div class="error-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9.172 16.172a4 4 0 0 1 5.656 0M9 10h.01M15 10h.01M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2z"/>
          </svg>
        </div>
        <h1 class="error-title">Service Unavailable</h1>
        <p class="error-subtitle">We couldn't connect to the server.</p>
        <p class="error-description">
          The backend service appears to be offline or unreachable.
          Please check that the server is running and try again.
        </p>
        <div class="error-actions">
          <button class="btn-retry" (click)="retry()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="btn-icon">
              <polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.51"/>
            </svg>
            Try Again
          </button>
        </div>
        <p class="error-hint">If the problem persists, please contact your system administrator.</p>
      </div>
    </div>
  `,
  styles: [`
    .service-unavailable-container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 60vh;
      padding: 2rem;
      font-family: 'avenir lt std', 'Segoe UI', sans-serif;
    }

    .error-card {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
      padding: 3rem 2.5rem;
      max-width: 480px;
      width: 100%;
      text-align: center;
    }

    .error-icon {
      width: 72px;
      height: 72px;
      margin: 0 auto 1.5rem;
      color: #C42828;
      background: rgba(196, 40, 40, 0.08);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 36px;
        height: 36px;
      }
    }

    .error-title {
      font-size: 1.75rem;
      font-weight: 700;
      color: #1a1a2e;
      margin: 0 0 0.5rem;
    }

    .error-subtitle {
      font-size: 1rem;
      font-weight: 600;
      color: #C42828;
      margin: 0 0 1rem;
    }

    .error-description {
      font-size: 0.9rem;
      color: #6b7280;
      line-height: 1.6;
      margin: 0 0 2rem;
    }

    .error-actions {
      margin-bottom: 1.5rem;
    }

    .btn-retry {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      background: #C42828;
      color: #fff;
      border: none;
      border-radius: 8px;
      padding: 0.65rem 1.5rem;
      font-size: 0.95rem;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.2s ease;

      &:hover {
        background: #a31f1f;
      }

      .btn-icon {
        width: 16px;
        height: 16px;
      }
    }

    .error-hint {
      font-size: 0.8rem;
      color: #9ca3af;
      margin: 0;
    }
  `]
})
export class ServiceUnavailableComponent {
  retry(): void {
    window.location.reload();
  }
}
